export const MemberType = {
  DISPLAY: 'display',
  MODERATOR: 'moderator',
  STREAMER: 'streamer',
  MOBILE: 'mobile',
  MOBILE_IOS: 'mobile_ios',
  MOBILE_ANDROID: 'mobile_android',
} as const;

export type MemberType = (typeof MemberType)[keyof typeof MemberType];
